// ─── Brand Config ─────────────────────────────────────────────────────────────
// Edit this file to update your brand across the entire app.

export const BRAND = {
  name: "CAPRINA",
  tagline: "WIN OR DIE",

  // Logo image path (relative to /public directory).
  // Drop your logo file into artifacts/caprina/public/ and set the filename here.
  // Supports: PNG, JPG, SVG, WEBP
  // Set to null to show the fallback letter instead.
  logoPath: "/logo.jpg" as string | null,

  // Fallback letter shown inside the colored square when no logoPath is set.
  fallbackLetter: "C",
};
